import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'react-bootstrap';

function ColContainer({ col1, col2, className = '' }) {
  return (
    <div className={classNames('d-flex flex-column flex-wrap', className)}>
      <Row className="flex-fill">
        <Col md={12} lg={6} className="my-3 d-flex flex-column">
          {col1}
        </Col>
        <Col md={12} lg={6} className="my-3 d-flex flex-column">
          {col2}
        </Col>
      </Row>
    </div>
  );
}

ColContainer.propTypes = {
  col1: PropTypes.node,
  col2: PropTypes.node,
  className: PropTypes.string,
};

export default ColContainer;
